import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { saloonImageOptions } from './views/saloon'

class X49Interior extends Component {
    constructor(props) {
        super(props);
        this.handleVeneerChange = this.handleVeneerChange.bind(this);
        this.handleFloorboardChange = this.handleFloorboardChange.bind(this);
    }

    handleVeneerChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Veneer = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFloorboardChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Floorboard = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = saloonImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Saloon' /></h1>
                    <h2><Trans defaults='Surfaces' /></h2>
                    <h3><Trans defaults='Veneer for furniture and bulkheads' /></h3>

                    <MaterialSelector label={this.props.configuration.Veneer.label} options={this.props.veneerOptions} value={this.props.configuration.Veneer} onChange={this.handleVeneerChange} />

                    <h3><Trans defaults='Laminate for floorboards' /></h3>

                    <MaterialSelector label={this.props.configuration.Floorboard.label} options={this.props.floorboardOptions} value={this.props.configuration.Floorboard} onChange={this.handleFloorboardChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49Interior);


// WEBPACK FOOTER //
// ./src/X49/X49Interior.js